var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.35 17.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #cb919a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.33,17.21c-1.08-1.54-2.15-3.07-3.23-4.61-.03-.04-.05-.07-.08-.11,1.44-1.32,2.35-3.2,2.35-5.3,0-3.96-3.22-7.19-7.19-7.19S0,3.22,0,7.19s3.22,7.19,7.19,7.19c1.43,0,2.76-.42,3.88-1.14.93,1.33,1.86,2.66,2.8,3.99.15.22.31.44.46.66,0,0,0,0,.01,0,.04.06.11.1.18.04.25-.18.51-.36.76-.53.06-.04.1-.13.05-.19ZM1.5,7.19C1.5,4.05,4.05,1.5,7.19,1.5s5.69,2.55,5.69,5.69-2.55,5.69-5.69,5.69S1.5,10.32,1.5,7.19Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.088be6609378ba99debddcbd7bb0d497.svg";
export { ForwardRef as ReactComponent };